import { createComponentStore } from '../../utils/createComponentStore';

const keyAuto = () =>
  'session_data' + (Math.floor(Math.random() * 90000000) + 10000).toString();

const initData = () => ({
  variables: [],
});

const { getStore, defaultStore } = createComponentStore({
  type: 'session_variables',
  endpoint: 'session-variables',
  registryKey: 'session-variables',
  initData,

  onLoadData: (rawData) => {
    const data = { ...rawData };
    // v1 compat: sessionVariableData → variables
    if (data.sessionVariableData && !data.variables) {
      data.variables = data.sessionVariableData;
      delete data.sessionVariableData;
    }
    return data;
  },

  extraState: () => ({
    placeholders: [],
    position: null,
    focus: null,
  }),

  extraActions: (set, get) => ({
    /** Backward-compat alias used by prefillComponentStores */
    setSessionVariables: (component) => {
      get().setComponentData(component);
    },

    setSessionVariableData: (variables) =>
      set((s) => ({ data: { ...s.data, variables } })),

    setFocus: (index) =>
      set({
        placeholders: [],
        position: index,
      }),

    sessionVariablesData: () => ({
      key: keyAuto(),
      type: 'text',
      value: '',
    }),

    keyAuto,

    getTemplate: () => {
      const s = get();
      return {
        componentId: s.componentId,
        name: s.name,
        position: s.position,
        data: JSON.parse(JSON.stringify(s.data)),
        type: s.type,
        lastModified: s.lastModified,
        placeholders: [...s.placeholders],
      };
    },
  }),
});

export const getSessionVariableStore = getStore;
export default defaultStore;
